export default class Access {
  static from(object) {
    try {
      return new Access(object);
    } catch (err) {
      console.log("error - no access");
      return err;
    }
  }

  constructor(initializer) {
    this.values = initializer;
  }


  get outcomeAccess() {
    if (this.values == undefined || this.values.length < 1) { return false}
    
    return this.values.filter(mod => mod.value === "outcome").length > 0;
  }

  get physicalAccess() {
    return this.values.filter(mod => mod.value === "physical").length > 0;
  }


  get configAccess() {
     // open config to all (11th January 2023)
    return true //this.values.filter(mod => mod.value === "configuration").length > 0;
  }

  get healthAccess() {
    return this.values.filter(mod => mod.value === "health").length > 0;
  }

  hasModule(value) {
    // open Pippa and Eddie to all (11th January 2023)
    if (["pippaeddie"].includes(value)) { 
      return true
    }

    return this.values.filter(mod => mod.value === value).length > 0;
  }

  get timelineAccess() {
    console.log("ACC timlein", this.values)
    return this.values.filter(mod => mod.value === "timeline").length > 0;
  }

  get challengeAccess() {
    return this.values.filter(mod => mod.value === "challenge").length > 0;
  }

  // Planning access

   get planningAccess() {
    return this.values.filter(mod => mod.value === "planning").length > 0;
  }

     get conceptAccess() {
    return this.values.filter(mod => mod.value === "concept").length > 0;
  }

  get peResourceBankAccess() {
    return this.values.filter(mod => mod.value === "peresourcebank").length > 0;
  }

  get maxWhitlockAccess() {
    return this.values.filter(mod => mod.value === "maxw").length > 0;
  }

   get pippaEddieAccess() {
    return this.values.filter(mod => mod.value === "pippaeddie").length > 0;
  }

   get danceAccess() {
    return this.values.filter(mod => mod.value === "dance").length > 0;
  }


  /// Sidebar access

    get resourceAccess() {
    return this.values.filter(mod => mod.value === "library").length > 0;
  }


    get videoLibraryAccess() {
    return this.values.filter(mod => mod.value === "  video-library").length > 0;
  }



   get toolboxAccess() {
    return this.values.filter(mod => mod.value === "toolbox").length > 0;
  }

  get ecAccess() {
    return this.values.filter(mod => mod.value === "extra-curricular").length > 0;
  }

     get eventAccess() {
    return this.values.filter(mod => mod.value === "competition").length > 0;
  }

  get reportingAccess() {
    return this.values.filter(mod => mod.value === "reporting").length > 0;
  }
  get healthAccess() {
    return this.values.filter(mod => mod.value === "health").length > 0;
  }

    /// Unit access

      get unitAccess() {
    return this.values.filter(mod => mod.value === "my-units").length > 0;
  }

    get assessmentAccess() {
    return this.values.filter(mod => mod.value === "assessment").length > 0;
  }

      get pupilVoiceAccess() {
    return this.values.filter(mod => mod.value === "pupil-voice").length > 0;
  }
}
